import type { SelectChangeEvent } from "@mui/material";
import { MenuItem, Select } from "@mui/material";
import type { DateRange } from "@mui/x-date-pickers-pro";
import { SingleInputDateRangeField } from "@mui/x-date-pickers-pro";
import { parseISO } from "date-fns";
import { formatDateOnly } from "@entrilia/shared/utilities/dateUtils";
import type { DateObjectFilter, DateObjectFilterOperator } from "../../api/types/objectTypes";
import { allDateObjectFilterOperators } from "../../api/types/objectTypes";
import { dateFilterOperatorCaptions } from "./objectFilterHelpers";

interface Props {
  filter: DateObjectFilter;
  onFilterChange: (filter: DateObjectFilter) => void;
}

const ObjectDateFilterEditorContent = ({ filter, onFilterChange }: Props) => {
  const handleFilterOperatorChange = (event: SelectChangeEvent<string>) => {
    const newOperator = event.target.value as DateObjectFilterOperator;
    onFilterChange({
      operator: newOperator,
      from: newOperator === "Range" ? filter.from : undefined,
      to: newOperator === "Range" ? filter.to : undefined,
    });
  };

  const handleRangeChange = (value: DateRange<Date>) => {
    const [from, to] = value;
    onFilterChange({
      ...filter,
      from: from ? formatDateOnly(from) : undefined,
      to: to ? formatDateOnly(to) : undefined,
    });
  };

  const rangeValue: DateRange<Date> = [
    filter.from ? parseISO(filter.from) : null,
    filter.to ? parseISO(filter.to) : null,
  ];

  return (
    <>
      <Select value={filter.operator} onChange={handleFilterOperatorChange} sx={{ flex: "0 0 12.5rem" }}>
        {allDateObjectFilterOperators.map((operator) => (
          <MenuItem key={operator} value={operator}>
            {dateFilterOperatorCaptions[operator]}
          </MenuItem>
        ))}
      </Select>

      {filter.operator === "Range" && (
        <SingleInputDateRangeField value={rangeValue} onChange={handleRangeChange} sx={{ flexGrow: 1, minWidth: 0 }} />
      )}
    </>
  );
};

export default ObjectDateFilterEditorContent;
